import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { setupSentry } from './utils/sentry';
import { installBestEffortPersistentStorage } from './services/persistent-storage';
import injectGlobals from './utils/inject-globals';
import { initializeCrossAppCache } from './utils/cross-app-cache';
import { selectSessionForMasq } from './utils/masq';
import { router } from './router';
import { installLinkPrefetching, registerRouteChunkPrefetch } from './services/router/prefetch';
import { registerSessionInvalidationRedirect } from './services/session/invalidation-redirect';
import { installRum } from './services/rum';
import { registerSiblingPreloads } from './routes/-sibling-preloads';
// Evaluated here, not with the first route chunk, so every `lazyRoute` page is in the
// prefetch registry before hover prefetch or a sibling preload asks for it.
import './routes/-route-pages';
import './index.scss';

setupSentry();
installBestEffortPersistentStorage();
installRum(router);
initializeCrossAppCache();
injectGlobals();
selectSessionForMasq();
installLinkPrefetching();
registerRouteChunkPrefetch(router);
registerSiblingPreloads();
registerSessionInvalidationRedirect();

// oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
ReactDOM.createRoot(document.getElementById('root') as HTMLElement, { identifierPrefix: 'hydra_' }).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
